export default __webpack_public_path__ + "static/media/sannicolas.603a49f5.jpg";